










import { Component, Prop, Vue } from "vue-property-decorator";
import CommonTabs from "@/employer/components/shared/CommonTabs.vue";
import CommonTab from "@/employer/components/shared/CommonTab.vue";
import CurrentPlan from "@/employer/components/myplans/CurrentPlan.vue";
import PreviousPlan from "@/employer/components/myplans/PreviousPlan.vue";

@Component({
  components: {
    CommonTabs,
    CommonTab,
    CurrentPlan,
    PreviousPlan,
  }
})
export default class MyPlans extends Vue {
}
